export const isValidUUID = (id) =>
  /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(
    id
  );

export function IdFromUrl(url) {
  // Split the URL by slashes
  const parts = url.split('/');

  // The last part of the URL is the ID
  const id = parts[parts.length - 1];

  return id;
}

export const apiCall = async (
  apiFunc,
  params,
  isCallAllowed,
  onSuccess,
  onError
) => {
  try {
    console.log('isCallAllowed', isCallAllowed, apiFunc);
    if (isCallAllowed) {
      const response = await apiFunc(params);
      const data = response?.data;
      console.log('Data is ', data);
      if (data?.status_code === 200) {
        onSuccess && onSuccess(data?.data);
      } else {
        onError && onError();
      }
    }
  } catch (error) {
    console.error(error);
    onError && onError();
  }
};
